import moment from 'moment';
moment.locale('ru');

export const customizeLocale = {
  // months list by order
  months: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],

  // week days by order
  weekDays: [
    {
      name: 'Понедельник',
      short: 'Пн',
    },
    {
      name: 'Вторник',
      short: 'Вт',
    },
    {
      name: 'Среда',
      short: 'Ср',
    },
    {
      name: 'Четверг',
      short: 'Чт',
    },
    {
      name: 'Пятница',
      short: 'Пт',
    },
    {
      name: 'Суббота',
      short: 'Сб',
      isWeekend: true,
    },
    {
      name: 'Воскресенье', // used for accessibility
      short: 'Вс', // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 6,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit) {
    return digit;
  },

  // texts in the date picker
  nextMonth: 'Следующий месяц',
  previousMonth: 'Предыдущий месяц',
  openMonthSelector: 'Выбрать месяц',
  openYearSelector: 'Выбрать год',
  closeMonthSelector: 'Закрыть',
  closeYearSelector: 'Закрыть',
  defaultPlaceholder: 'Выбрать...',

  // for input range value
  from: 'от',
  to: 'до',


  // used for input value when multi dates are selected
  digitSeparator: ',',

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

function noop() {}

export function getDate(dateString) {
  if (!dateString) {
    return null;
  }
  const date = moment(dateString).format('D MMMM YYYY').split(' ');
  return {
    day: date[0],
    month: date[1],
    year: date[2]
  };
}

export function getDateFromDoubleDate(startDateObj, endDateObj) {
  const years = startDateObj.year === endDateObj.year
    ? [startDateObj.year]
    : [startDateObj.year, endDateObj.year];
  const months = years.length === 1 && startDateObj.month === endDateObj.month
    ? [startDateObj.month]
    : [startDateObj.month, endDateObj.month];
  const days = years.length === 1 && months.length === 1 && startDateObj.day === endDateObj.day
    ? [startDateObj.day]
    : [startDateObj.day, endDateObj.day];
  if (years.length === 1 && months.length === 1 && days.length === 1) {
    return `${days[0]} ${months[0]} ${years[0]}`;
  } else if (years.length !== 1) {
    return `${days[0]} ${months[0]} ${years[0]} - ${days[1] || days[0]} ${months[1] || months[0]} ${years[1]}`;
  } else if (years.length === 1 && months.length !== 1) {
    return `${days[0]} ${months[0]} - ${days[1] || days[0]} ${months[1]} ${years[0]}`;
  } else if (years.length === 1 && months.length === 1 && days.length !== 1) {
    return `${days[0]} - ${days[1]} ${months[0]} ${years[0]}`;
  } else {
    return '';
  }
}

export function getDateFromEventDays(eventDays) {
  if (!eventDays) {
    return null;
  }
  let minStartDate = eventDays
    .filter(eventDay => eventDay !== null)
    .map(eventDay => Date.parse(eventDay.START_DATE))
    .reduce((min, eventDay) => {
      if (eventDay < min) {
        return eventDay;
      } else {
        return min;
      }
    }, Number.MAX_SAFE_INTEGER);
  minStartDate = minStartDate === Number.MAX_SAFE_INTEGER ? null : minStartDate;
  const parsedMinStartDate = !!minStartDate ? moment(new Date(minStartDate).toISOString()).format('D MMMM YYYY') : null;

  let maxEndDate = eventDays
    .filter(eventDay => eventDay !== null)
    .map(eventDay => Date.parse(eventDay.END_DATE))
    .reduce((max, eventDay) => {
      if (eventDay > max) {
        return eventDay;
      } else {
        return max;
      }
    }, 0);
  maxEndDate = maxEndDate === 0 ? null : maxEndDate;
  const parsedMaxEndDate = !!maxEndDate ? moment(new Date(maxEndDate).toISOString()).format('D MMMM YYYY') : null;

  if (!parsedMinStartDate) {
    return null;
  } else if (parsedMaxEndDate) {
    if (parsedMinStartDate === parsedMaxEndDate) {
      return parsedMinStartDate;
    } else {
      const startDate = parsedMinStartDate.split(' ');
      const startDateObj = {
        day: startDate[0],
        month: startDate[1],
        year: startDate[2]
      };
      const endDate = parsedMaxEndDate.split(' ');
      const endDateObj = {
        day: endDate[0],
        month: endDate[1],
        year: endDate[2]
      };
      return getDateFromDoubleDate(startDateObj, endDateObj);
    }
  } else {
    return null;
  }
}

export function getSingleDate(startDate, endDate, eventDays) {
  if (eventDays && !!eventDays.length) {
    return getDateFromEventDays(eventDays);
  }
  if (!startDate) {
    return null;
  } else if (!endDate) {
    const date = getDate(startDate);
    return `${date.day} ${date.month} ${date.year}`;
  } else {
    return getDateFromDoubleDate(getDate(startDate), getDate(endDate));
  }
};

// return {day: number, month: number, year: number}
// day: real day (for example from 1 to 31 for Jan)
// month: real month (from 1 to 12)
// year: real year
// date: string, for example "2022-04-09T09:30:00.0000000"
function parseDate(date) {
  const dateObject = new Date(Date.parse(date));
  return {
    day: dateObject.getDate(),
    month: dateObject.getMonth() + 1,
    year: dateObject.getFullYear()
  };
}

function datesToArray(dates) {
  return dates
    .map(date => {
      if (!date.START_DATE) {
        return null;
      }
      if (!date.END_DATE) {
        return [date.START_DATE];
      }
      if (moment(date.START_DATE).format('D MMMM YYYY') === moment(date.END_DATE).format('D MMMM YYYY')) {
        return [date.START_DATE];
      } else {
        const numDates = [];
        const numStartDate = Date.parse(date.START_DATE);
        let numEndDate = Date.parse(date.END_DATE);

        while (numEndDate >= numStartDate) {
          numDates.push(numEndDate);
          numEndDate -= 24 * 3600 * 1000;
        }
        return numDates.map(numDate => new Date(numDate).toISOString()).reverse();
      }
    })
    .filter(date => date !== null);
}

// return false if only START_DATE or duration less than 2 days including
// startDate: string | null,
// endDate: string | null,
// dates: [{START_DATE: "2022-04-09T09:30:00.0000000", "END_DATE": "2022-04-09T14:30:00.0000000"}, {}] | null
export function getIsDatesShown(startDate, endDate, dates) {
  if (dates) {
    const arrayedDates = datesToArray(dates);
    if (!arrayedDates.length) {
      noop();
    } else if (arrayedDates.length === 1) {
      return arrayedDates[0].length > 2;
    } else if (arrayedDates.length === 2) {
      return arrayedDates[0].length + arrayedDates[1].length > 2;
    } else {
      return true;
    }
  }
  if (!startDate || !endDate) return false;

  const diff = Math.floor((Date.parse(endDate) - Date.parse(startDate)) / (1000 * 3600 * 24));
  return diff >= 2;
}

export function getDates(startDate, endDate, dates) {
  if (dates) {
    const arrayedDates = datesToArray(dates)
      .reduce((allDates, date) => {
        return [...allDates, ...date];
      }, []);
    if (!!arrayedDates.length) {
      return arrayedDates.map(date => parseDate(date));
    }
  }

  if (!startDate || !endDate) {
    return [];
  }

  const numDates = [];
  const numStartDate = Date.parse(startDate);
  let numEndDate = Date.parse(endDate);

  while (numEndDate >= numStartDate) {
    numDates.push(numEndDate);
    numEndDate -= 24 * 3600 * 1000;
  }

  return numDates
    .map(numDate => new Date(numDate).toISOString())
    .map(date => parseDate(date))
    .reverse();
}
